module.exports = __webpack_public_path__ + "img/confirmed.894c49c1.gif";